import Vue from 'vue'
import App from './App.vue'
import globalData from './lib/globalData'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import router from './router'
import VueGtag from "vue-gtag";

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './scss/app.scss'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

import VueJWT from 'vuejs-jwt'
Vue.use(VueJWT);

import VModal from 'vue-js-modal'
Vue.use(VModal, {
  dialog: true,
  dynamicDefaults: {
    draggable: true,
    resizable: true,
    height: 'auto'
  }
});
Vue.use(VueGtag, {
  config: { id: "G-8RJ9622K8T" }
});

import Tooltip from 'vue-directive-tooltip';
Vue.use(Tooltip);

import io from 'socket.io-client';
const socket = io(process.env.VUE_APP_SOCKET_PRO, {transports: ['polling', 'websocket'], secure: true});

socket.on('connect', () => {
  if (globalData.logged_in_user?.username) {
    socket.emit('online', {username: globalData.logged_in_user.username, company: globalData.logged_in_user.company.code});
  }
});
import { Multiselect } from 'vue-multiselect'

import VueApexCharts from "vue-apexcharts";
Vue.use(VueApexCharts);
Vue.component('ApexChart', VueApexCharts)

// eslint-disable-next-line vue/multi-word-component-names
Vue.component('multiselect', Multiselect)

Vue.config.productionTip = false

Vue.mixin({
  data: () => ({
    globalData,
    socket
  }),

  methods: {
    online: function () {
      socket.emit('online', {username: globalData.logged_in_user.username, company: globalData.logged_in_user.company.code});
    }
  }
})

new Vue({
  router,
  render: h => h(App),
  directives: {
    tooltip: Tooltip,
  },
}).$mount('#app')
